export default "__VITE_ASSET__Cml8X3lo__"